import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { getApiUrl } from '../constants';
import LoadingPage from './LoadingPage';
import ErrorPage from './ErrorPage';
import { UPSELL_QUERY_PARAM } from '../hooks/useShopifyInstall';
import API from 'utils/api';
import { DASHBOARD_PATH } from 'routes';
import {
  readBrowserMetaAttribution,
  setupShopPayload,
} from '../lib/metaAttribution';

const setupShop = async (params: { [key: string]: string }) => {
  const attribution = readBrowserMetaAttribution();
  const response = await API().post(
    `${getApiUrl()}/shopify/setup`,
    setupShopPayload(params, attribution)
  );
  if (response.status !== 200) {
    throw Error(`Setup shop failed with status code ${response.status}`);
  }
};

const createRedirectUrl = (search: URLSearchParams) => {
  const shop = search.get('shop');
  const host = search.get('host');
  const upsell = search.get(UPSELL_QUERY_PARAM);

  const apiKey = process.env.REACT_APP_SHOPIFY_API_KEY;

  const params = new URLSearchParams({
    shop: shop ?? '',
    host: host ?? '',
    upsell: upsell ?? '',
  });

  return `https://${atob(
    host ?? ''
  )}/apps/${apiKey}${DASHBOARD_PATH}?${params.toString()}`;
};

const OAuthRedirect: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const search = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  useEffect(() => {
    const go = async () => {
      let params: { [key: string]: string } = {};
      for (const [key, value] of search) {
        params = { ...params, [key]: value };
      }

      try {
        await setupShop(params);
      } catch (e) {
        console.error('OAuthRedirect: Error during shop setup:', e);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    go();
  }, [search]);

  useEffect(() => {
    if (loading) {
      return;
    }

    window.location.assign(createRedirectUrl(search));
  }, [loading, navigate, search]);

  if (loading) {
    return <LoadingPage />;
  }

  if (error) {
    return <ErrorPage />;
  }

  return <></>;
};

export default OAuthRedirect;
